// extracted by mini-css-extract-plugin
module.exports = {"title":"_4ebb642","reportHeader":"_9920971"};